import { BkRoutes } from 'bkng';

import { id } from './id/id';

export const organization: BkRoutes = [
    {
        path: "id",
        label: "Organization by ID",
        children: id,
    },
];
